import { carriersSelector, fetchCarriersIfNeeded } from '../../carriers';
import { connect } from 'react-redux';
import { InsuranceCarrierDropdownView } from './InsuranceCarrierDropdownView';

export function mapStateToProps(state, props) {
    const carriers = carriersSelector(state, props.insuranceType);

    if (!carriers || carriers.length === 0) {
        return {
            isLoading: true,
            carriers: [],
        };
    }

    return {
        isLoading: false,
        carriers,
    };
}

export const mapDispatchToProps = {
    fetchCarriersIfNeeded,
};

export const InsuranceCarrierDropdownConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsuranceCarrierDropdownView);
